import { render, staticRenderFns } from "./vkAlert.vue?vue&type=template&id=17202836&scoped=true"
import script from "./vkAlert.vue?vue&type=script&lang=js"
export * from "./vkAlert.vue?vue&type=script&lang=js"
import style0 from "./vkAlert.vue?vue&type=style&index=0&id=17202836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17202836",
  null
  
)

export default component.exports